import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

@Injectable()
export class MenuCommonService {

  userMenu = [
    {
      title: 'Account',
      icon: 'icofont-user-alt-7',
      link: '/pages/account',
    },
    {
      title: 'My Apps',
      icon: 'icofont-samsung-galaxy',
      link: '/pages/channels',
    },
    {
      title: 'Log out',
      icon: 'icofont-logout',
      link: '/auth/logout',
    },
  ];

}
